import React, { useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';
import { Routes } from '../../../utils';
import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useStoreContext } from '../../App/StoreProvider';
import './JobActivity.scss';
import { Alert, Dropdown, OverlayTrigger, Table } from 'react-bootstrap';
import {
    GET_ACTIVITY_SUMMARY,
    GET_ALL_DRIVERS_BY_REGION,
    GET_DRIVERS_IN_STANDBY,
    GET_DRIVER_ACTIVITY,
    GET_LOADID_AND_SANDPO,
    GET_STANDBY_DRIVERS,
} from '../../../graphql/client/queries';
import { useMutation, useQuery } from '@apollo/client/react';
import Row from 'react-bootstrap/Row';
import { Error, Loading } from '../../_common';
import * as Actions from '../../../store/actions/addLoadModal';
import DownloadIcon from '@mui/icons-material/Download';
import {
    AssignDriverToLoad,
    GetActivitySymmary,
    GetActivitySymmary_getActivitySummary as ActSummary,
    GetDriverActivity,
    GetDriverActivity_getDriverActivity as DriverAct,
    GetStandbyDrivers,
    GetStandbyDrivers_getStandbyDrivers as standByDrivers,
    GetDriversInStandby_getDriversInStandby as standbyDriversForAssigning,
} from '../../../types/schemaTypes';
import { formatDateUtcToLocal } from '../../../utils/helpers/datetimeHelper';
import { CurrentActivityFilter } from '../../Filter/CurrentActivityFilter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as CurrentActivityActions from '../../../store/actions/currentActivity';
import AssignStandByDriverModal from './AssignStandByDriverModal/AssignStandByDriverModal';
import { ASSIGN_DRIVER_TO_LOAD } from '../../../graphql/client/mutations';
import DispatchModal from '../../AddLoads/DispatchModal';
import DriverLoadNotes from './DriverLoadNotes/DriverLoadNotes';
import AddEditDriverLoadNoteModal from './AddEditDriverLoadNoteModal/AddEditDriverLoadNoteModal';
import { ModalForm, Option } from './interface';
import {
    ADD_DRIVERLOAD_NOTES,
    EDIT_DRIVERLOAD_NOTES,
    DELETE_DRIVERLOAD_NOTES,
    RESOLVE_DRIVERLOAD_NOTE,
    RESOLVE_ALLDRIVERLOAD_NOTES,
} from '../../../graphql/client/mutations';
import {
    AddDriverLoadNotes,
    EditDriverLoadNotes,
    DeleteDriverLoadNotes,
    ResolveDriverLoadNote,
    ResolveAllDriverLoadNotes,
} from '../../../types/schemaTypes';

import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper'

import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import JobMenuItems from '../../Header/JobMenuItemsHeader/JobMenuItems';

let driverLoadNotes: any | undefined;

const JobActivity = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();
    const [state, dispatch] = useStoreContext();
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') + '';
    const abortController = new AbortController();
    const [listHeight, setListHeight] = useState(window.screen.height);

    const [showAssignDriverModal, setShowAssignDriverModal] = useState(false);
    const [proppant, setProppant] = useState<string | null>('');
    const [sandPO, setSandPO] = useState<string | null>('');
    const [transportationPO, setTransportationPO] = useState<string | null>('');
    const [lofa, setLofa] = useState<string | null>('');
    const [proppantId, setProppantId] = useState<number | null>(0);
    const [lofaId, setLofaId] = useState<number | null>(0);
    const [regionId, setRegionId] = useState<number | null>(0);
    const [showDispatchModal, setShowDispatchModal] = useState<boolean>(false);
    const [driverLoadNoteLoadId, setDriverLoadNoteLoadId] = useState(0);
    const [showAddEditDriverLoadNoteModal, setshowAddEditDriverLoadNoteModal] = useState(false);
    const [modalForm, setModalForm] = useState(ModalForm.EMPTY);
    const [showActuals, setShowActuals] = useState(true); // true = actuals, false = estimates
    const { jobId } = useParams()
    const jobIdVal: any = jobId
    const gridRef = useRef<any>(null)

    let loadingTotal1 = 0;
    let loadedTotal1 = 0;
    let onsiteTotal1 = 0;
    let assignedTotal1 = 0;
    let createdTotal1 = 0;
    let acceptedTotal1 = 0;
    let activetrucksTotal1 = 0;
    const [showFilter, setShowFilter] = React.useState(false);
    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isAddDriverLoadNotesEnabled = authContext.userHasPermission(PermissionEnum.AddDriverLoadNotes);
    const isViewDriverLoadNotesEnabled = authContext.userHasPermission(PermissionEnum.ViewDriverLoadNotes);
    const isCurrentActivityEnabled = authContext.userHasPermission(PermissionEnum.CurrentActivityAssignDriver);
    const canEditLoadFieldOp = authContext.userHasPermission(PermissionEnum.UpdateLoadFieldOp);
    const [htmlData, setHtmlData] = useState('');

    const copyToClipboardMap = new Map([
        [1, 'Activity Summary'],
        [2, 'Standby Drivers'],
        [3, 'Driver Details']
    ])

    const {
        currentActivity: { filters = { carrierIds: [], driverPositionIds: [] ,proppantIds:[], lofaIds:[], statusIds:[] }, searchPhrase, searchPhraseSubset },   
    } = state;
    const { driverPositionIds = [] } = filters;
    const toasterOptions = { duration: 2500 };
    const openLoadProfile = (loadId: number | null, boxNumber: string | null): void => {
        const URL = `${window.location.origin}${Routes.LOAD_PROFILE.route}`;
        const newTab = window.open(URL + loadId, '_blank');
        //const newTab = window.open(URL + loadId, '_self');
        setTimeout(function (): void {
            if (newTab) {
                newTab.document.title = boxNumber!;
            }
        }, 100);
    };
    const openLoadFieldOp = (loadId: number | null, boxNumber: string | null): void => {
        const URL = `${window.location.origin}${Routes.LOAD_FIELD_OP.route}`;
        const newTab = window.open(URL + loadId, '_blank');
        setTimeout(function (): void {
            if (newTab) {
                newTab.document.title = boxNumber!;
            }
        }, 100);
    };
    const getClassName = (overDueFlag: string | null): string => {
        let names = 'JobActivity-Alert';
        if (overDueFlag === 'Y') names = names + 'Disabled';
        if (overDueFlag === 'N') names = names + '';
        if (overDueFlag === 'E') names = names + 'GrayedOut';
        return names;
    };
    const evaluateStatus = (status: string | null): string => {
        let newstatus;
        if (status == 'Assigned') newstatus = 'Accepted';
        else newstatus = status;
        return newstatus;
    };
    let jobName: string | null = '';

    const onAddDriverLoadNoteClick = driverActivityDetails => {
        driverLoadNotes = undefined;
        setModalForm(ModalForm.ADD_DRIVERLOADNOTE);
        setDriverLoadNoteLoadId(driverActivityDetails.loadId);
        setshowAddEditDriverLoadNoteModal(true);
    };

    const handleOnEdit = (id: number, notes: string) => {
        setModalForm(ModalForm.EDIT_DRIVERLOADNOTE);
        driverLoadNotes = { id, notes };
        setshowAddEditDriverLoadNoteModal(true);
    };

    const onDriverLoadDeleteSuccess = () => {
        toast.success('Note deleted successfully', toastOpt);

    };

    const onCompletedDeleteDriverLoadNote = (data: DeleteDriverLoadNotes): void => {
        if (data.deleteDriverLoadNotes === null) return;
        const deleteNoteErrors = data.deleteDriverLoadNotes.errors;
        onDriverLoadDeleteSuccess();
    };

    const [deleteDriverLoadNote] = useMutation<DeleteDriverLoadNotes>(DELETE_DRIVERLOAD_NOTES, {
        onCompleted: onCompletedDeleteDriverLoadNote,
        refetchQueries: () => {
            return [
                {
                    query: GET_DRIVER_ACTIVITY,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            carrierIds: filters.carrierIds,
                            proppantIds: filters.proppantIds,
                            lofaIds: filters.lofaIds,
                            status: filters.statusIds,
                        },
                    },
                },
            ];
        },
    });

    const onDriverLoadResolveSuccess = () => {
        toast.success('Note resolved successfully', toastOpt);

    };

    const onCompletedResolveDriverLoadNote = (data: ResolveDriverLoadNote): void => {
        if (data.resolveDriverLoadNote === null) return;
        const resolveNoteErrors = data.resolveDriverLoadNote.errors;
        onDriverLoadResolveSuccess();
    };

    const [resolveDriverLoadNote] = useMutation<ResolveDriverLoadNote>(RESOLVE_DRIVERLOAD_NOTE, {
        onCompleted: onCompletedResolveDriverLoadNote,
        refetchQueries: () => {
            return [
                {
                    query: GET_DRIVER_ACTIVITY,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            carrierIds: filters.carrierIds,
                            proppantIds: filters.proppantIds,
                            lofaIds: filters.lofaIds,
                            status: filters.statusIds,
                        },
                    },
                },
            ];
        },
    });

    const onAllDriverLoadNoteResolveSuccess = () => {
        toast.success('Note resolved successfully', toastOpt);

    };

    const onCompletedResolveAllDriverLoadNotes = (data: ResolveAllDriverLoadNotes): void => {
        if (data.resolveAllDriverLoadNotes === null) return;
        const resolveNoteErrors = data.resolveAllDriverLoadNotes.errors;
        onAllDriverLoadNoteResolveSuccess();
    };

    const [resolveAllDriverLoadNotes] = useMutation<ResolveAllDriverLoadNotes>(RESOLVE_ALLDRIVERLOAD_NOTES, {
        onCompleted: onCompletedResolveAllDriverLoadNotes,
        refetchQueries: () => {
            return [
                {
                    query: GET_DRIVER_ACTIVITY,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            carrierIds: filters.carrierIds,
                            proppantIds: filters.proppantIds,
                            lofaIds: filters.lofaIds,
                            status: filters.statusIds,
                        },
                    },
                },
            ];
        },
    });

    const handleOnDelete = (id: number) => {
        const deleteDriverLoadNoteInput = {
            id: id,
        };
        deleteDriverLoadNote({ variables: { input: deleteDriverLoadNoteInput } });
    };

    const handleOnResolve = (id: number) => {
        const resolveDriverLoadNoteInput = {
            id: id,
        };
        resolveDriverLoadNote({ variables: { input: resolveDriverLoadNoteInput } });
    };

    const handleOnResolveAllNotes = (id: number) => {
        const resolveDriverLoadNoteInput = {
            loadId: id,
        };
        resolveAllDriverLoadNotes({ variables: { input: resolveDriverLoadNoteInput } });
    };

    const columns = React.useMemo(() => {
        return [
            {
                field: 'driverName',
                headerName: 'Driver Name',
                width: 400,
                suppressAutoSize: true,
                resizable: false,
                cellRenderer: ({ valueFormatted, value, data }) => {

                    return (
                        <div style={{ display: 'flex', alignItems: "center" }}>
                            {isAddDriverLoadNotesEnabled && (
                                <i
                                    style={{ fontSize: '18px', marginRight: '5px' }}
                                    className="material-icons Info-Icon"
                                    onClick={() => onAddDriverLoadNoteClick(data)}
                                >
                                    add
                                </i>
                            )}
                            <div className={showActuals ? 'JobActivity-Actual' : ''}>{value}</div>
                            <span
                                className="conv-icon on-shift DriverItem-BellyDumpIcon"
                                title={
                                    data.checkInWithBellyDump
                                        ? 'Checked in with belly dump (hopper)'
                                        : 'Checked in with box'
                                }
                            >
                                <FontAwesomeIcon
                                    icon={['fas', data.checkInWithBellyDump ? 'dumpster' : 'cube']}
                                    color="#b6bd00"
                                />
                            </span>
                            {isViewDriverLoadNotesEnabled && data.notes && data.notes.length > 0 && (
                                <DriverLoadNotes
                                    data={data}
                                    onEditNote={handleOnEdit}
                                    onDeleteNote={handleOnDelete}
                                    onResolveNote={handleOnResolve}
                                    onResolveAllNotes={handleOnResolveAllNotes}
                                ></DriverLoadNotes>
                            )}
                        </div>
                    );
                }
            },
            {
                field: 'proppantName',
                headerName: 'Proppant Name',
                maxWidth: 135,
                minWidth: 134,
                suppressAutoSize: true,
                cellRenderer: ({ value }) => {
                    return <span className={showActuals ? 'JobActivity-Actual' : ''}>{value}</span>;
                }
            },
            {
                field: 'lofaName',
                headerName: 'Lofa Name',
                maxWidth: 180,
                minWidth: 179,
                suppressAutoSize: true,
                cellRenderer: ({ value }) => {
                    return <span className={showActuals ? 'JobActivity-Actual' : ''}>{value}</span>;
                }
            },
            {
                field: 'status',
                headerName: 'Status',
                maxWidth: 95,
                minWidth: 94,
                suppressAutoSize: true,
                cellRenderer: ({ value, data }) => {
                    return <span className={showActuals ? 'JobActivity-Actual' : ''}>{evaluateStatus(value)}</span>;
                }
            },
            {
                field: 'loadId',
                headerName: 'Load',
                maxWidth: 100,
                minWidth: 98,
                suppressAutoSize: true,
                classes: 'JobActivityItem-Name',
                cellRenderer: ({ value, data }) => {
                    return <span className="JobActivityItem-Name" onClick={() => openLoadProfile(data['loadId'], jobName)}>{value}</span>
                }
            },
            {
                field: 'acceptTime',
                headerName: 'Accept Time',
                maxWidth: 180,
                minWidth: 170,
                suppressAutoSize: true,
                cellRenderer: ({ value, data }) => {
                    return <span className={showActuals ? 'JobActivity-Actual' : ''}>{formatDateUtcToLocal(value)}</span>;
                }
            },
            {
                field: 'etaLoading',
                headerName: 'Loading',
                maxWidth: 180,
                minWidth: 160,
                suppressAutoSize: true,
                sortable: true,
                comparator: showActuals ? (valueA, valueB, nodeA, nodeB) => {
                    // When showing actuals, only sort actual values (overdueAtLofaIn is 'N' or null)
                    const isActualA = nodeA.data['overdueAtLofaIn'] === 'N' || nodeA.data['overdueAtLofaIn'] === null;
                    const isActualB = nodeB.data['overdueAtLofaIn'] === 'N' || nodeB.data['overdueAtLofaIn'] === null;
                    
                    // Only sort if both are actuals
                    if (isActualA && isActualB) {
                        return new Date(valueA).getTime() - new Date(valueB).getTime();
                    }
                    
                    // If only A is actual, A comes first
                    if (isActualA && !isActualB) {
                        return -1;
                    }
                    
                    // If only B is actual, B comes first
                    if (!isActualA && isActualB) {
                        return 1;
                    }
                    
                    // If neither are actuals, maintain original order
                    return 0;
                } : (valueA, valueB, nodeA, nodeB) => {
                    // When showing estimates, sort all values including estimates
                    const timeA = valueA ? new Date(valueA).getTime() : 0;
                    const timeB = valueB ? new Date(valueB).getTime() : 0;
                    
                    return timeA - timeB;
                },
                cellRenderer: ({ value, data }) => {
                    if (showActuals) {
                        // When showing actuals, only show items that are actual (black) - hide estimates and overdue
                        if (data['overdueAtLofaIn'] === 'N' || data['overdueAtLofaIn'] === null) {
                            return <span className="JobActivity-Actual">{formatDateUtcToLocal(value)}</span>;
                        } else {
                            return <span className="JobActivity-Actual"></span>; // Show empty for non-actual items
                        }
                    } else {
                        // When showing estimates, use original color coding
                        return <span className={getClassName(data['overdueAtLofaIn'])}>{formatDateUtcToLocal(value)}</span>;
                    }
                }
            },
            {
                field: 'etaLoaded',
                headerName: 'Loaded',
                maxWidth: 180,
                minWidth: 160,
                suppressAutoSize: true,
                sortable: true,
                comparator: showActuals ? (valueA, valueB, nodeA, nodeB) => {
                    // When showing actuals, only sort actual values (overdueAtLofaOut is 'N' or null)
                    const isActualA = nodeA.data['overdueAtLofaOut'] === 'N' || nodeA.data['overdueAtLofaOut'] === null;
                    const isActualB = nodeB.data['overdueAtLofaOut'] === 'N' || nodeB.data['overdueAtLofaOut'] === null;
                    
                    // Only sort if both are actuals
                    if (isActualA && isActualB) {
                        return new Date(valueA).getTime() - new Date(valueB).getTime();
                    }
                    
                    // If only A is actual, A comes first
                    if (isActualA && !isActualB) {
                        return -1;
                    }
                    
                    // If only B is actual, B comes first
                    if (!isActualA && isActualB) {
                        return 1;
                    }
                    
                    // If neither are actuals, maintain original order
                    return 0;
                } : (valueA, valueB, nodeA, nodeB) => {
                    // When showing estimates, sort all values including estimates
                    const timeA = valueA ? new Date(valueA).getTime() : 0;
                    const timeB = valueB ? new Date(valueB).getTime() : 0;
                    
                    return timeA - timeB;
                },
                cellRenderer: ({ value, data }) => {
                    if (showActuals) {
                        // When showing actuals, only show items that are actual (black) - hide estimates and overdue
                        if (data['overdueAtLofaOut'] === 'N' || data['overdueAtLofaOut'] === null) {
                            return <span className="JobActivity-Actual">{formatDateUtcToLocal(value)}</span>;
                        } else {
                            return <span className="JobActivity-Actual"></span>; // Show empty for non-actual items
                        }
                    } else {
                        // When showing estimates, use original color coding
                        return <span className={getClassName(data['overdueAtLofaOut'])}>{formatDateUtcToLocal(value)}</span>
                    }
                }
            },
            {
                field: 'etaOnsite',
                headerName: 'Onsite',
                maxWidth: 180,
                minWidth: 140,
                suppressAutoSize: true,
                sortable: true,
                comparator: showActuals ? (valueA, valueB, nodeA, nodeB) => {
                    // When showing actuals, only sort actual values (overdueAtDestinationIn is 'N' or null)
                    const isActualA = nodeA.data['overdueAtDestinationIn'] === 'N' || nodeA.data['overdueAtDestinationIn'] === null;
                    const isActualB = nodeB.data['overdueAtDestinationIn'] === 'N' || nodeB.data['overdueAtDestinationIn'] === null;
                    
                    // Only sort if both are actuals
                    if (isActualA && isActualB) {
                        return new Date(valueA).getTime() - new Date(valueB).getTime();
                    }
                    
                    // If only A is actual, A comes first
                    if (isActualA && !isActualB) {
                        return -1;
                    }
                    
                    // If only B is actual, B comes first
                    if (!isActualA && isActualB) {
                        return 1;
                    }
                    
                    // If neither are actuals, maintain original order
                    return 0;
                } : (valueA, valueB, nodeA, nodeB) => {
                    // When showing estimates, sort all values including estimates
                    const timeA = valueA ? new Date(valueA).getTime() : 0;
                    const timeB = valueB ? new Date(valueB).getTime() : 0;
                    
                    return timeA - timeB;
                },
                cellRenderer: ({ value, data }) => {
                    if (showActuals) {
                        // When showing actuals, only show items that are actual (black) - hide estimates and overdue
                        if (data['overdueAtDestinationIn'] === 'N' || data['overdueAtDestinationIn'] === null) {
                            return <span className="JobActivity-Actual">{formatDateUtcToLocal(value)}</span>;
                        } else {
                            return <span className="JobActivity-Actual"></span>; // Show empty for non-actual items
                        }
                    } else {
                        // When showing estimates, use original color coding
                        return <span className={getClassName(data['overdueAtDestinationIn'])}>{formatDateUtcToLocal(value)}</span>
                    }
                }
            },
            {
                field: 'etaDelivered',
                headerName: 'Delivered',
                maxWidth: 180,
                minWidth: 140,
                suppressAutoSize: true,
                sortable: true,
                comparator: showActuals ? (valueA, valueB, nodeA, nodeB) => {
                    // When showing actuals, only sort actual values (overdueAtDestinationOut is 'N' or null)
                    const isActualA = nodeA.data['overdueAtDestinationOut'] === 'N' || nodeA.data['overdueAtDestinationOut'] === null;
                    const isActualB = nodeB.data['overdueAtDestinationOut'] === 'N' || nodeB.data['overdueAtDestinationOut'] === null;
                    
                    // Only sort if both are actuals
                    if (isActualA && isActualB) {
                        return new Date(valueA).getTime() - new Date(valueB).getTime();
                    }
                    
                    // If only A is actual, A comes first
                    if (isActualA && !isActualB) {
                        return -1;
                    }
                    
                    // If only B is actual, B comes first
                    if (!isActualA && isActualB) {
                        return 1;
                    }
                    
                    // If neither are actuals, maintain original order
                    return 0;
                } : (valueA, valueB, nodeA, nodeB) => {
                    // When showing estimates, sort all values including estimates
                    const timeA = valueA ? new Date(valueA).getTime() : 0;
                    const timeB = valueB ? new Date(valueB).getTime() : 0;
                    
                    return timeA - timeB;
                },
                cellRenderer: ({ value, data }) => {
                    if (showActuals) {
                        // When showing actuals, only show items that are actual (black) - hide estimates and overdue
                        if (data['overdueAtDestinationOut'] === 'N' || data['overdueAtDestinationOut'] === null) {
                            return <span className="JobActivity-Actual">{formatDateUtcToLocal(value)}</span>;
                        } else {
                            return <span className="JobActivity-Actual"></span>; // Show empty for non-actual items
                        }
                    } else {
                        // When showing estimates, use original color coding
                        return <span className={getClassName(data['overdueAtDestinationOut'])}>{formatDateUtcToLocal(value)}</span>
                    }
                }
            },
            {
                field: 'fieldSignOff',
                headerName: 'Field Sign-off',
                suppressAutoSize: true,
                maxWidth: 120,
                minWidth: 119,
                cellRenderer: ({ value, data }) => {
                    let returnValue = "";
                    const status = evaluateStatus(data.status);

                    if (status === 'On-site' && canEditLoadFieldOp) {
                        returnValue = 'Field Sign-off'
                    }

                    const openLoad = () => {
                        const status = evaluateStatus(data.status);

                        if (status === 'On-site' && canEditLoadFieldOp) {
                            openLoadFieldOp(data['loadId'], jobName);
                        }
                    }
                    const className = 'JobActivityItem-Name';
                    return <span className={className} onClick={openLoad}>{returnValue}</span>
                }
            },
        ];
    }, [showActuals]);

    const columnsStandyDrivers = [
        {
            field: 'driverName',
            headerName: 'Driver Name',
            cellRenderer: ({ value, data }) => {
                const bellyDumpIcon = (
                    <span
                        className="conv-icon on-shift DriverItem-BellyDumpIcon"
                        title={
                            data.checkInWithBellyDump
                                ? 'Checked in with belly dump (hopper)'
                                : 'Checked in with box'
                        }
                    >
                        <FontAwesomeIcon
                            icon={['fas', data.checkInWithBellyDump ? 'dumpster' : 'cube']}
                            color="#b6bd00"
                        />
                    </span>
                );
                return data.driverPoolNotes ? (
                    <>
                        {value}
                        {bellyDumpIcon}
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<span className="StandByDrivers-DirectionsTooltip">{data.driverPoolNotes}</span>}
                        >
                            <i className="material-icons StandbyDrivers-InfoIcon">info</i>
                        </OverlayTrigger>
                    </>
                ) : (
                    <>
                        {value}
                        {bellyDumpIcon}
                    </>
                );
            }
        },
        {
            field: 'carrierName',
            headerName: 'Carrier Name',
            // sort: true,
            // headerSortingClasses: 'SortingHeaderStyle',
        },
        {
            field: 'loadRequested',
            headerName: 'Minutes since Load Requested',
            // sort: true,
            // headerSortingClasses: 'SortingHeaderStyle',
        },
        {
            field: 'loadRejected',
            headerName: 'Minutes since Load Rejected',
            // sort: true,
            // headerSortingClasses: 'SortingHeaderStyle',
        },
        {
            field: 'loadDelivered',
            headerName: 'Minutes since Load Delivered',
            // sort: true,
            // headerSortingClasses: 'SortingHeaderStyle',
        },
        {
            field: 'assignedTime',
            headerName: 'Assigned Time',
            cellRenderer: ({ value, data }) => {
                return formatDateUtcToLocal(value);
            }
        },
    ];

    const onDriverLoadSaveSuccess = () => {
        toast.success('Note added successfully', toastOpt);

    };

    const onCompletedSaveDriverLoadNote = (data: AddDriverLoadNotes): void => {
        if (data.addDriverLoadNotes === null) return;
        const saveNoteErrors = data.addDriverLoadNotes.errors;
        onDriverLoadSaveSuccess();
    };

    const onDriverLoadEditSuccess = () => {
        toast.success('Note updated successfully', toastOpt);

    };

    const onDriverLoadEditFail = (errorMessage) => {
        const alertMessage = errorMessage[0].includes('Not permitted to update the job notes created by another user') ? 'This note can only be edited by the user who created it. You can add another note instead' : errorMessage[0];
        toast.error(alertMessage, toastOpt);

    }

    const onCompletedEditDriverLoadNote = (data: EditDriverLoadNotes): void => {

        if (data.editDriverLoadNotes === null) return;
        const editNoteErrors = (data.editDriverLoadNotes.errors && data.editDriverLoadNotes.errors.length > 0) ? data.editDriverLoadNotes.errors : null;

        if (editNoteErrors) {

            onDriverLoadEditFail(editNoteErrors)
        } else {

            onDriverLoadEditSuccess();
        }
    };

    const [editDriverLoadNote] = useMutation<EditDriverLoadNotes>(EDIT_DRIVERLOAD_NOTES, {
        onCompleted: onCompletedEditDriverLoadNote,
        refetchQueries: () => {
            return [
                {
                    query: GET_DRIVER_ACTIVITY,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            carrierIds: filters.carrierIds,
                            proppantIds: filters.proppantIds,
                            lofaIds: filters.lofaIds,
                            status: filters.statusIds,
                        },
                    },
                },
            ];
        },
    });

    const [saveDriverLoadNote] = useMutation<AddDriverLoadNotes>(ADD_DRIVERLOAD_NOTES, {
        onCompleted: onCompletedSaveDriverLoadNote,
        refetchQueries: () => {
            return [
                {
                    query: GET_DRIVER_ACTIVITY,
                    variables: {
                        input: {
                            jobId: parseInt(jobIdVal),
                            carrierIds: filters.carrierIds,
                            proppantIds: filters.proppantIds,
                            lofaIds: filters.lofaIds,
                            status: filters.statusIds,
                        },
                    },
                },
            ];
        },
    });

    const handleOnHide = (): void => {
        // selectedUser = undefined;
        // setErrorMessage('');
        setshowAddEditDriverLoadNoteModal(false);
    };
    const handleOnSave = async (id: number, notes: string): Promise<void> => {
        setshowAddEditDriverLoadNoteModal(false);
        if (driverLoadNotes) {
            const editDriverLoadNoteInput = {
                id: id,
                newValues: {
                    notes: notes,
                },
            };
            await editDriverLoadNote({ variables: { input: editDriverLoadNoteInput } });
        } else {
            const variables = { input: { notes, loadId: driverLoadNoteLoadId, driverId: 0 } };
            await saveDriverLoadNote({ variables });
        }
    };

    const [assignDriver, { loading: mutationLoading }] = useMutation<AssignDriverToLoad>(ASSIGN_DRIVER_TO_LOAD, {
        refetchQueries: [
            {
                query: GET_ACTIVITY_SUMMARY,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        carrierIds: filters.carrierIds,
                        proppantIds: filters.proppantIds,
                        lofaIds: filters.lofaIds,
                        status: filters.statusIds,
                    },
                },
            },
            {
                query: GET_STANDBY_DRIVERS,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        carrierIds: filters.carrierIds,
                    },
                },
            },
            {
                query: GET_DRIVERS_IN_STANDBY,
                variables: {
                    jobId: parseInt(jobIdVal),
                    lofaId: lofaId,
                },
            },
            {
                query: GET_ALL_DRIVERS_BY_REGION,
                variables: {
                    regionId: regionId,
                },
            },
            {
                query: GET_LOADID_AND_SANDPO,
                variables: {
                    input: {
                        jobId: parseInt(jobIdVal),
                        lofaId: lofaId,
                        proppantId: proppantId,
                        sandPO: '',
                    },
                },
            },
        ],
    });

    const { loading: activitySummaryLoading, error, data: summaryData } = useQuery<GetActivitySymmary>(GET_ACTIVITY_SUMMARY, {
        variables: {
            input: {
                jobId: parseInt(jobIdVal),
                carrierIds: filters.carrierIds,
                proppantIds: filters.proppantIds,
                lofaIds: filters.lofaIds,
                status: filters.statusIds,
            },
        },
        fetchPolicy: 'network-only',
        pollInterval: 120000,
    });

    const componentRef = useRef(null);

    const { loading: standbyDriversLoading, data: standbyDriverData } = useQuery<GetStandbyDrivers>(GET_STANDBY_DRIVERS, {
        variables: {
            input: {
                jobId: parseInt(jobIdVal),
                carrierIds: filters.carrierIds,
            },
        },
        fetchPolicy: 'network-only',
        pollInterval: 120000,
    });

    const componentDriverRef = useRef(null);

    const { loading: driverActivityLoading, data: driverData } = useQuery<GetDriverActivity>(GET_DRIVER_ACTIVITY, {
        variables: {
            input: {
                jobId: parseInt(jobIdVal),
                carrierIds: filters.carrierIds,
                proppantIds: filters.proppantIds,
                lofaIds: filters.lofaIds,
                status: filters.statusIds,
            },
        },
        fetchPolicy: 'network-only',
        pollInterval: 120000,
    });

    if (error) {
        return <Error error={error} />;
    }

    const summaries: ActSummary[] = [];
    if (summaryData && summaryData.getActivitySummary && summaryData.getActivitySummary.length !== 0) {
        summaryData.getActivitySummary.forEach((element: ActSummary | null): void => {
            if (element !== null) {
                summaries.push(element);
            }
        });
        if (summaries.length > 0) {
            jobName = summaries[0].wellName;
            document.title = jobName ? jobName : tabTitle;
            for (let idx = 0; idx < summaries.length; idx++) {
                createdTotal1 += summaries[idx].created!;
                acceptedTotal1 += summaries[idx].accepted!;
                loadingTotal1 += summaries[idx].loading!;
                loadedTotal1 += summaries[idx].loaded!;
                onsiteTotal1 += summaries[idx].unloading!;
                assignedTotal1 += summaries[idx].assigned!;
                activetrucksTotal1 += summaries[idx].totalActiveTrucks!;
            }
        }
    }


    // const standbyDrivers: standByDrivers[] = [];
    // const standbyDrivers: any = [];
    const standbyDrivers: any = React.useMemo(() => {
        const standbyDrivers: any = [];
        if (standbyDriverData && standbyDriverData.getStandbyDrivers && standbyDriverData.getStandbyDrivers.length !== 0) {
            standbyDriverData.getStandbyDrivers.forEach((element: standByDrivers | null): void => {
                if (element !== null) {
                    standbyDrivers.push(element);
                }
            });
        }
        return standbyDrivers
    }, [standbyDriverData]);

    const driversummaries: any = React.useMemo(() => {
        const driversummaries: DriverAct[] = [];
        if (driverData && driverData.getDriverActivity) {
            driverData.getDriverActivity.forEach((element: DriverAct | null): void => {
                if (element !== null) {
                    driversummaries.push(element);
                }
            });
        }
        
        // Apply client-side filtering for Driver Status
        if (driverPositionIds && driverPositionIds.length > 0) {
            return driversummaries.filter((driver: DriverAct) => {
                // Map driverPositionIds to status values
                // 1 = Active (estimates not red), 2 = Idle (estimates red)
                const isActive = driverPositionIds.includes(1);
                const isIdle = driverPositionIds.includes(2);
                
                // Check if driver has red estimates (overdue)
                const hasRedEstimates = driver.overdueAtLofaIn === 'Y' || 
                                      driver.overdueAtLofaOut === 'Y' || 
                                      driver.overdueAtDestinationIn === 'Y' || 
                                      driver.overdueAtDestinationOut === 'Y';
                
                if (isActive && isIdle) {
                    return true; // Show all if both are selected
                } else if (isActive) {
                    return !hasRedEstimates; // Show drivers with normal estimates
                } else if (isIdle) {
                    return hasRedEstimates; // Show drivers with red estimates
                }
                
                return false;
            });
        }
        
        return driversummaries;
    }, [driverData, driverPositionIds]);
    const currentActivityRefreshHandler = (event: any) => {
        //dispatch(CurrentActivityActions.setSearchPhrase(''));
        // dispatch(CurrentActivityActions.setFilterSearchPhrase([], 'CARRIER', ''));
        setShowFilter(prevShowFilter => !prevShowFilter);
    };

    const handleOnClickAssign = async (driverId, driverName, loadId): Promise<void> => {
        await dispatch(Actions.setCreatedLoadIds([loadId ?? -1]));
        await dispatch(Actions.assignDriverToLoadId(loadId, driverName, driverId, true, driverName));
        setShowAssignDriverModal(false);
        setShowDispatchModal(true);
        await assignDriver({
            variables: { driverId: driverId, loadId: loadId, isPrimaryDriver: true },
        });
        setProppantId(null);
    };



    const onGridReadyCallback = (params) => {
        // Don't auto-size columns to prevent layout issues when toggling between actuals/estimates
        // gridRef!.current!.columnApi.sizeColumnsToFit();
    }

    const defaultColDef = React.useMemo<any>(() => {
        return {
            flex: 1,
            minWidth: 75,
            resizable: false,
            wrapText: true,
            autoHeight: true,
            suppressMovable: true,
            suppressAutoSize: true,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'flex-start',
                wordBreak: 'break-word',
            }),
        };
    }, []);

    const generateDynamicHtml = (id, data) => {

        const table = copyToClipboardMap.get(id);
        let html = "";

        // Summaries table
        // If data is provided, use it instead of summaries/driversummaries
        if (table === 'Activity Summary') {
            const summaryData = data || summaries;
            if (summaryData.length > 0) {
                html = `<div style="font-family: Avenir-Book; font-size: 15px">Activity Summary</div><table style="border: 1px solid black;
        border-collapse: collapse;">
        <thead>
            <tr>    
                <!-- Add more columns as needed -->
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">ProppantName</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">LofaName</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Sand PO</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Created</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Assigned</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Accepted</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Loading</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Loaded</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Onsite</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Total Active Trucks</th>
            </tr>
        </thead>
        <tbody>`
                summaryData.forEach((item) => {
                    html = html + `<tr><td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['proppantName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['lofaName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['sandPO']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['created']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['assigned']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['accepted']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['loading']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['loaded']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['unloading']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['totalActiveTrucks']}</td>
                </tr>
                `
                })


                html += `
        </tbody>
        `;
                html += `
                                <tr>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Total</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;"></td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;"></td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${createdTotal1}</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${assignedTotal1}</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${acceptedTotal1}</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${loadingTotal1}</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${loadedTotal1}</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${onsiteTotal1}</td>
                                    <td style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">${activetrucksTotal1}</td>
                                    <td></td>
                                </tr>
                            </table> <br>`

            } else {
                html += `<div style="font-family: Avenir-Book; font-size: 11px">No Activity Summary Available.</div> <br><br>`
            }
        }

        // Standby Drivers
        if (table === 'Standby Drivers') {
            html += `<div style="font-family: Avenir-Book; font-size: 15px">Standby Drivers in Job Pool</div> \n`
            if (standbyDrivers.length > 0) {
                html+=`<table style="border: 1px solid black;
        border-collapse: collapse;">
        <thead>
            <tr>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Driver Name</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Carrier Name</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Minutes since Load Requested</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Minutes since Load Rejected</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Minutes since Load Delivered</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Assigned Time</th>
            </tr>
        </thead>
        <tbody>
           `

                standbyDrivers.forEach((item) => {
                    html = html + ` <tr><td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['driverName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['carrierName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['loadRequested']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['loadRejected']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['loadDelivered']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['onShift']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${formatDateUtcToLocal(item['assignedTime'])}</td>
                </tr>`
                })

                html += `
            </tbody>
            </table><br><br>`;
            } else {
                html += `<div style="font-family: Avenir-Book; font-size: 11px">No Standby Drivers Available.</div> <br><br>`
            }
        }

        // else Driver Details
        else if (table === 'Driver Details') {
            const driverData = data || driversummaries;
            if (driverData.length > 0) {
                html += `<div style="font-family: Avenir-Book; font-size: 15px">Driver Details</div><table style="border: 1px solid black;
        border-collapse: collapse;">
        <thead>
            <tr>
                <!-- Add more columns as needed -->
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Driver Name</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Proppant Name</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Lofa Name</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Status</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Load</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Accept Time</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Loading</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Loaded</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Onsite</th>
                                    <th style="font-size: 11px;    font-family: Avenir-Book, sans-serif;  font-weight: 700;   border: 1px solid black;
                                    border-collapse: collapse;">Delivered</th>
            </tr>
        </thead>
        <tbody>
            `

                driverData.forEach((item) => {
                    html += `<tr><td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['driverName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['proppantName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['lofaName']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${evaluateStatus(item['status'])}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['loadId']}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${formatDateUtcToLocal(item['acceptTime'])}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['overdueAtLofaIn'] === 'N' ? formatDateUtcToLocal(item['etaLoading']) : ''}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['overdueAtLofaOut'] === 'N' ? formatDateUtcToLocal(item['etaLoaded']) : ''}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['overdueAtDestinationIn'] === 'N' ? formatDateUtcToLocal(item['etaOnsite']) : ''}</td>
                <td style="font-size: 11px; border: 1px solid black;
                border-collapse: collapse;">${item['overdueAtDestinationOut'] === 'N' ? formatDateUtcToLocal(item['etaDelivered']) : ''}</td>
                </tr>`
                });

                html += `
            </tbody>
            </table>`

            } else {
                html += `<div style="font-family: Avenir-Book; font-size: 11px">No Driver Summary avaliable.</div><br><br>`
            }
        }
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, 'text/html');
        return htmlDoc.documentElement.outerHTML;
    }

    const copyToClipboard = async (id) => {
        try {
            let html;
            
            // For driver details table, get the sorted data from AG Grid
            if (id === 3 && gridRef.current) {
                const sortedData: any[] = [];
                gridRef.current.api.forEachNodeAfterFilterAndSort((node: any) => {
                    sortedData.push(node.data);
                });
                html = generateDynamicHtml(id, sortedData);
            } else {
                html = generateDynamicHtml(id, undefined);
            }

            const clipboardItem = new ClipboardItem({
                'text/html': new Blob([html], { type: 'text/html' }),
            });

            await navigator.clipboard.write([clipboardItem]);
            toast.success(`${copyToClipboardMap.get(id)} table data copied successfully`, toastOpt);

        } catch (error) {
            console.log("error -", error);
            toast.error('Something went wrong!', toastOpt);
        }

    }

    return (
        <div className="Messages-Container">
            <ToastContainer />
            <div className="Messages-BodyContainer">
                <CurrentActivityFilter
                    showFilter={showFilter}
                    showFilterHandler={() => setShowFilter(prevShowFilter => !prevShowFilter)}
                    jobId={parseInt(jobIdVal)}
                />
            </div>

            <div id="loadsListContainer" className="JobActivity-List" style={{ height: listHeight }}>
                <div className="JobActivity-Header-Container">
                    <div
                        className="Filter-HeaderIconContainer"
                        onClick={currentActivityRefreshHandler}
                        style={{ position: 'relative' }}
                    >
                        <i className="material-icons">filter_list</i>
                        {(filters.carrierIds && filters.carrierIds.length > 0) || (driverPositionIds && driverPositionIds.length > 0) ? (
                            <FontAwesomeIcon
                                icon={['fas', 'check-circle']}
                                color="#fb6e3a"
                                size="sm"
                                style={{ position: 'absolute', top: '-4px', right: '-4px' }}
                            />
                        ) : null}
                    </div>
                    <div className="JobProfile-HeaderTitle">Current Activity: {jobName}</div>

                    <JobMenuItems jobId={jobId ?? "0"} menu='jobActivity'/>
                </div>

                <Row>
                    <span className="JobActivity-LabelText">Activity Summary</span>
                    <ContentCopyRoundedIcon
                        className='JobActivity-Copy'
                        onClick={() => copyToClipboard(1)}
                    />
                </Row>
                <Row className="JobActivity-SummaryData">
                    {activitySummaryLoading ? (
                        <div className="JobActivity-Spinner-Container">
                            <Loading />
                        </div>
                    ) : summaries.length > 0 ? (
                        <Table striped bordered hover ref={componentRef} className="tabletest">
                            <thead>
                                <tr>
                                    <th>ProppantName</th>
                                    <th>LofaName</th>
                                    <th>Sand PO</th>
                                    <th>Transportation PO</th>
                                    <th>Created</th>
                                    <th>Assigned</th>
                                    <th>Accepted</th>
                                    <th>Loading</th>
                                    <th>Loaded</th>
                                    <th>Onsite</th>
                                    <th>Total Active Trucks</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: teams">
                                {summaries.map(i => (
                                    <tr key={i['proppantName']}>
                                        <td>{i['proppantName']}</td>
                                        <td>{i['lofaName']}</td>
                                        <td>{i['sandPO']}</td>
                                        <td>{i['transportationPO']}</td>
                                        <td>{i['created']}</td>
                                        <td>{i['assigned']}</td>
                                        <td>{i['accepted']}</td>
                                        <td>{i['loading']}</td>
                                        <td>{i['loaded']}</td>
                                        <td>{i['unloading']}</td>
                                        <td>{i['totalActiveTrucks']}</td>
                                        <td width={150}>
                                            {i['created'] == 0 ? (
                                                <div className="GridViewItem-List-Header Assign-driver-tab"></div>
                                            ) : (
                                                <>
                                                    {isCurrentActivityEnabled ? (
                                                        <>
                                                            {' '}
                                                            <div
                                                                className="Assign-driver-tab"
                                                                onClick={() => {
                                                                    setShowAssignDriverModal(true);
                                                                    setProppant(i['proppantName']);
                                                                    setSandPO('');
                                                                    setTransportationPO(i['transportationPO']);
                                                                    setLofa(i['lofaName']);
                                                                    setProppantId(i['proppantId']);
                                                                    setLofaId(i['lofaId']);
                                                                    setRegionId(i['regionId']);
                                                                }}
                                                            >
                                                                <i className="material-icons Assign-Driver-Icon">
                                                                    add_circle
                                                                </i>
                                                                <span className="Assign-driver-link">
                                                                    Assign Driver
                                                                </span>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>{createdTotal1}</th>
                                    <th>{assignedTotal1}</th>
                                    <th>{acceptedTotal1}</th>
                                    <th>{loadingTotal1}</th>
                                    <th>{loadedTotal1}</th>
                                    <th>{onsiteTotal1}</th>
                                    <th>{activetrucksTotal1}</th>
                                    <th></th>
                                </tr>
                            </tfoot>
                        </Table>
                    ) : (
                        <div className="NoResult-Container JobActivity-NoResult-Container">
                            <div className="NoResult-Second-Title-Primary JobActivity-NoResult-Title">
                                No Activity Summary Available.
                            </div>
                        </div>
                    )}
                </Row>
                <Row>
                    <span className="JobActivity-LabelText">Standby Drivers in Job Pool</span>
                    {/* <i class="fa-regular fa-clone"></i>
                     */}
                    {/* <FontAwesomeIcon
                                icon={faClone}
                                color="#009dc7"
                                size="sm"
                                // style={{ position: 'absolute', top: '-4px', right: '-4px' }}
                            /> */}
                    <ContentCopyRoundedIcon
                        className='JobActivity-Copy'
                        onClick={() => copyToClipboard(2)}
                    />
                </Row>
                <Row className="JobActivity-StandByDriversData">
                    {standbyDriversLoading ? (
                        <div className="JobActivity-Spinner-Container">
                            <Loading />
                        </div>
                    ) : standbyDrivers.length > 0 ? (
                        // <BootstrapTable
                        //     keyField="id"
                        //     data={standbyDrivers}
                        //     columns={columnsStandyDrivers}
                        //     striped
                        //     bordered
                        //     hover
                        //     classes="DriverActivityTable"
                        //     bootstrap4
                        //     table-responsive
                        // />
                        <div
                            className="JobActivity-AgGridTable ag-theme-quartz"
                            style={{ width: "98%", height: '100%', marginLeft: "10px" }}
                        >
                            <AgGridReact
                                rowData={standbyDrivers}
                                defaultColDef={defaultColDef}
                                domLayout={'autoHeight'}
                                columnDefs={columnsStandyDrivers}
                                enableCellTextSelection={true}
                                copyHeadersToClipboard={true}
                                enableRangeSelection={true}
                                animateRows={false}
                            /></div>
                    ) : (
                        <div className="NoResult-Container JobActivity-NoResult-Container">
                            <div className="NoResult-Second-Title-Primary JobActivity-NoResult-Title">
                                No Standby Drivers Available.
                            </div>
                        </div>
                    )}
                </Row>
                <Row>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <span className="JobActivity-LabelText">Driver Details</span>
                            <ContentCopyRoundedIcon
                                className='JobActivity-Copy'
                                onClick={() => copyToClipboard(3)}
                            />
                        </div>
                        <div className="JobActivity-Toggle-Container">
                            <div className="JobActivity-Toggle-Box">
                                <div
                                    className={`JobActivity-Toggler ${!showActuals && 'JobActivity-Toggler-Right'}`}
                                />
                                <div className="JobActivity-Toggle-Actuals" onClick={() => setShowActuals(true)}>
                                    Actuals
                                </div>
                                <div className="JobActivity-Toggle-Estimates" onClick={() => setShowActuals(false)}>
                                    Estimates
                                </div>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row className="JobActivity-Data">
                    {driverActivityLoading ? (
                        <div className="JobActivity-Spinner-Container">
                            <Loading />
                        </div>
                    ) : driversummaries.length > 0 ? (
                        // <BootstrapTable
                        //     keyField="id"
                        //     data={driversummaries}
                        //     columns={columns2}
                        //     //defaultSorted={defaultSorted}
                        //     striped
                        //     bordered
                        //     hover
                        //     classes="DriverActivityTable"
                        //     bootstrap4
                        //     //headerClasses="DriverActivityHeader"
                        //     table-responsive
                        // />
                        <div
                            className="JobActivity-AgGridTable ag-theme-quartz"
                            style={{ width: "100%", height: '100%', marginLeft: "5px", marginRight: "5px" }}
                        >
                            <AgGridReact
                                ref={gridRef}
                                onGridReady={onGridReadyCallback}
                                defaultColDef={defaultColDef}
                                rowData={driversummaries}
                                enableRangeSelection={true}
                                enableCellTextSelection={true}
                                copyHeadersToClipboard={true}
                                // processCellForClipboard={processCellForClipboard}
                                copyGroupHeadersToClipboard={true}
                                // domLayout={'autoHeight'}
                                columnDefs={columns}
                                animateRows={false}
                            //autoSizeStrategy={autoSizeStrategy}
                            />
                        </div>
                    ) : (
                        <div className="NoResult-Container JobActivity-NoResult-Container">
                            <div className="NoResult-Second-Title-Primary JobActivity-NoResult-Title">
                                No Driver Details Available.
                            </div>
                        </div>
                    )}
                </Row>
            </div>

            {jobIdVal && lofaId && proppantId ? (
                <AssignStandByDriverModal
                    show={showAssignDriverModal}
                    proppant={proppant}
                    sandPO={sandPO}
                    transportationPO={transportationPO}
                    lofa={lofa}
                    jobName={jobName}
                    jobId={parseInt(jobIdVal)}
                    proppantId={proppantId}
                    lofaId={lofaId}
                    regionId={regionId}

                    onClickBack={() => {
                        setShowAssignDriverModal(false);
                        setProppantId(null);
                    }}
                    onClickAssign={(driverId, driverName, loadId) => handleOnClickAssign(driverId, driverName, loadId)}
                    mutationLoading={mutationLoading}
                />
            ) : (
                ''
            )}

            <DispatchModal
                isFromLoads={true}
                isSplitLoad={false}
                show={showDispatchModal}
                onClickHide={() => setShowDispatchModal(false)}
            />

            <AddEditDriverLoadNoteModal
                show={showAddEditDriverLoadNoteModal}
                editedNote={driverLoadNotes}
                modalForm={modalForm}
                onClickHide={handleOnHide}
                onClickSave={handleOnSave}
            ></AddEditDriverLoadNoteModal>
        </div>
        // eslint-disable-next-line

    );
};

export default JobActivity;
